import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React from 'react'

const PatrolLogsTable = ({
    patrolLogs
}) => {
    const columns = React.useMemo(
        () => [
            {
                header: 'Site',
                accessorKey: 'site_location.site.name'
            },
            {
                header: 'Security Officer',
                accessorKey: 'security_officer.name'
            },
            {
                header: 'Location',
                accessorKey: 'site_location.name'
            },
            {
                header: 'Longitude',
                accessorKey: 'longitude'
            },
            {
                header: 'Latitude',
                accessorKey: 'latitude'
            }
        ], []
    );

    const table = useReactTable({
        data: patrolLogs,
        columns,
        getCoreRowModel: getCoreRowModel()
    });

    if (patrolLogs.length === 0){
        return <div className="text-center">No patrol logs found</div>
    }
  return (
    <table className='table table-striped'>
        <thead>
            {table.getHeaderGroups().map((headerGroup) =>
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) =>
                        <th key={header.id}>{header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}</th>
                    )}
                </tr>
            )}
        </thead>
        <tbody>
            {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                ))}
                </tr>
            ))}
        </tbody>
    </table>
  )
}

export default PatrolLogsTable